import Vue from 'vue';

export default Vue.mixin({
  data: () => {
    return {
      draggingRow: null,
      draggingRowIndex: null,
    };
  },
  methods: {
    dragstart(payload) {
      this.draggingRow = payload.row;
      this.draggingRowIndex = payload.index;
      payload.event.dataTransfer.effectAllowed = 'copy';
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy';
      payload.event.target.closest('tr').classList.add('is-selected');
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      payload.event.preventDefault();
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      const droppedOnRowIndex = payload.index;
      if (this.draggingRowIndex != droppedOnRowIndex)
        this.onOrderChange(
          this.draggingRow.id,
          this.draggingRowIndex,
          droppedOnRowIndex
        );
    },
    reorderArray(arr, from, to) {
      const tmp = [...arr];
      tmp.splice(to, 0, tmp.splice(from, 1)[0]);

      return tmp;
    },
  },
});
